module.exports = __webpack_public_path__ + "img/city_taoyuan2.2c8546b7.png";